
import React from 'react';
import CityMetauxPage from '@/components/valorisation/CityMetauxPage';

const AchatMetauxMazamet = () => {
  return (
    <CityMetauxPage
      cityName="Mazamet"
      departmentName="Tarn"
      departmentCode="81"
      region="Occitanie"
      description="Ville industrielle du Tarn au patrimoine textile riche, Mazamet bénéficie de notre expertise dans le rachat de métaux issus de l'industrie textile, mécanique et de la transformation."
      specialities={[
        "Métaux de l'industrie textile",
        "Équipements mécaniques industriels",
        "Métaux de transformation",
        "Ferraille de montagne tarnaise"
      ]}
      nearbyAreas={[
        "Aussillon", "Payrin-Augmontel", "Bout-du-Pont-de-Larn", "Labruguière", "Brassac", "Saint-Amans-Soult"
      ]}
      heroImage="https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=1280&q=80"
    />
  );
};

export default AchatMetauxMazamet;
